/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomExtendedProductResponseDto } from '../models/pom-extended-product-response-dto';
import { PomProductRequestDtoDto } from '../models/pom-product-request-dto-dto';
import { PomSimpleProductsResponseDto } from '../models/pom-simple-products-response-dto';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetch5
   */
  static readonly Fetch5Path = '/offer/product/{id}';

  /**
   * Get product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetch5()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetch5$Response(params: {

    /**
     * Id of the product
     */
    id: string;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomExtendedProductResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.Fetch5Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomExtendedProductResponseDto>;
      })
    );
  }

  /**
   * Get product
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetch5$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetch5(params: {

    /**
     * Id of the product
     */
    id: string;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<PomExtendedProductResponseDto> {

    return this.fetch5$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomExtendedProductResponseDto>) => r.body as PomExtendedProductResponseDto)
    );
  }

  /**
   * Path part for operation update4
   */
  static readonly Update4Path = '/offer/product/{id}';

  /**
   * Update product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update4()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update4$Response(params: {

    /**
     * Id of the updated product
     */
    id: string;
    'Accept-Language'?: any;
    body: PomProductRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.Update4Path, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Update product
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update4$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update4(params: {

    /**
     * Id of the updated product
     */
    id: string;
    'Accept-Language'?: any;
    body: PomProductRequestDtoDto
  },
  context?: HttpContext

): Observable<number> {

    return this.update4$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation list6
   */
  static readonly List6Path = '/offer/product';

  /**
   * Get list of products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list6()` instead.
   *
   * This method doesn't expect any request body.
   */
  list6$Response(params: {

    /**
     * Number of page
     */
    page: number;

    /**
     * Size of page
     */
    size: number;

    /**
     * Filter that can be applied to the list of results
     */
    filter?: Array<string>;

    /**
     * Sorting that can be applied to the list of results
     */
    sort?: Array<string>;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomSimpleProductsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.List6Path, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('filter', params.filter, {});
      rb.query('sort', params.sort, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomSimpleProductsResponseDto>;
      })
    );
  }

  /**
   * Get list of products
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list6$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list6(params: {

    /**
     * Number of page
     */
    page: number;

    /**
     * Size of page
     */
    size: number;

    /**
     * Filter that can be applied to the list of results
     */
    filter?: Array<string>;

    /**
     * Sorting that can be applied to the list of results
     */
    sort?: Array<string>;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<PomSimpleProductsResponseDto> {

    return this.list6$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomSimpleProductsResponseDto>) => r.body as PomSimpleProductsResponseDto)
    );
  }

  /**
   * Path part for operation create5
   */
  static readonly Create5Path = '/offer/product';

  /**
   * Create new product
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create5()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create5$Response(params: {
    'Accept-Language'?: any;
    body: PomProductRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.Create5Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Create new product
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create5$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create5(params: {
    'Accept-Language'?: any;
    body: PomProductRequestDtoDto
  },
  context?: HttpContext

): Observable<number> {

    return this.create5$Response(params,context).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
